import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, Injector, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { isNullOrEmpty, getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { FaqService } from 'src/app/features/faq/services/faq.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FaqSearchResult } from 'src/app/core/models/faq/faq-search-result';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';

@Component({
  selector: 'laas-faq-maintenance',
  templateUrl: './faq-maintenance.component.html',
  styleUrls: ['./faq-maintenance.component.scss']
})
export class FaqMaintenanceComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewFaqMaintenance;
  currentLang: string = this.laasSetting.language;

  isSearchFormOpen = true;
  searchForm: FormGroup;
  facilityOptions: LaasOption[] = [];
  isActivatedOptions: LaasOption[];
  faqResults: FaqSearchResult[];
  columns: DateTableColumn[];
  isLoading = false;
  tenantOptions: any[];

  constructor(
    injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private faqService: FaqService,
    private fb: FormBuilder
  ) {
    super(injector);
    this.tenantOptions = [];

    this.searchForm = this.fb.group({
      facility: [],
      keyword: '',
      isActivated: null,
      tenantList: []
    });

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({
          label: x.optionDesc,
          value: x.optionCode
        }));
      }
    });

    this.isActivatedOptions = [];

    this.columns = [
      { field: 'question', header: 'FaqMaintenance.MainTable.Question', sort: true },
      { field: 'answer', header: 'FaqMaintenance.MainTable.Answer', sort: true },
      { field: 'isActivated', header: 'FaqMaintenance.MainTable.IsActivated', sort: true },
      { field: 'createUser', header: 'FaqMaintenance.MainTable.CreateBy', sort: true },
      { field: 'createDt', header: 'FaqMaintenance.MainTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateUser', header: 'FaqMaintenance.MainTable.UpdateBy', sort: true },
      { field: 'updateDt', header: 'FaqMaintenance.MainTable.UpdateTime', dataType: 'date', sort: true },
      { field: '__action', header: 'FaqMaintenance.MainTable.Action', sort: false },
      { field: 'facility', header: 'FaqMaintenance.Search.Facility', sort: false },
      { field: 'tenant', header: 'NotificationSubscribtion.Form.Tenant', sort: false }

    ];

    this.faqResults = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.isActivatedOptions = [
      { label: 'Y', value: 1 },
      { label: 'N', value: 0 }
    ];

    // rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.notificationSubScriptionService.getTenantOptions().subscribe({
      next: (options: any[]) => {
        this.tenantOptions = options.map(x => ({
          label: x.tenantCode + " - " + x.tenantName,
          value: x.tenantCode
        }));
        this.tenantOptionsFilter();
        this.tenantOptions.unshift({
          value: "ALL",
          label: "ALL - 全部"
        });
      }

    });
    setTimeout(() => this.searchBtnClick(null), 500);
  }

  searchBtnClick(event: any): void {
    this.isLoading = true;
    console.log(this.getUserDataScope().authTenantList);
    const uniqueString = [...new Set(this.getUserDataScope().authTenantList)];
    if ((isNullOrEmpty(this.searchForm.get("tenantList")?.value) || this.searchForm.get("tenantList")?.value.length == 0) && this.userProfile.userType == 'Tenant') {
      var searchTenantList = uniqueString;
      searchTenantList.push("ALL");
      this.searchForm.controls.tenantList.setValue(searchTenantList);
    }
    console.log(this.searchForm.get("tenantList")?.value);
    this.faqService.searchFaq(this.searchForm.value).subscribe({
      next: (result: FaqSearchResult[]) => {
        this.faqResults = result;
        this.changeQuestionToString();
      },
      complete: () => {
        this.isLoading = false;
      }
    });

  }

  resetBtnClick(event: any): void{
    this.searchForm.reset();
  }

  addFaq(event: any): void {
    this.routeStateService.navigateTo('/Setting/FaqEdit');
  }

  gotoModify(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/Setting/FaqEdit', {seqNo: rowData.seqNo});
  }

  getUserDataScope() {
    const dataScopList = getDataScopeByPermission(this.userProfile, PermissionConstants.ViewCustomerChopSignSample);
    const authOrgIdList = dataScopList.map((x:any) =>{ return x.orgId; }).filter((x:any) => !isNullOrEmpty(x));
    const authDeptList = dataScopList.map((x:any) =>{ return x.dept; }).filter((x:any) => !isNullOrEmpty(x));
    const authConsigneeKeyList = dataScopList.map((x:any) =>{ return x.consigneeKey; }).filter((x:any) => !isNullOrEmpty(x));
    const authTenantList = dataScopList.map((x:any) =>{ return x.tenant; }).filter((x:any) => !isNullOrEmpty(x));

    return {authOrgIdList: authOrgIdList, authDeptList: authDeptList, authConsigneeKeyList: authConsigneeKeyList, authTenantList: authTenantList};
  }

  changeQuestionToString() {
    if (this.faqResults != null) {
      for (const rowData of this.faqResults) {
        if (rowData.answer != undefined) {
          rowData.answer = rowData.answer.replace(/<[^>]*>/g, '');
        }
        if (rowData.question != undefined) {
          rowData.question = rowData.question.replace(/<[^>]*>/g, '');
        }
      }
    }
  }

  tenantOptionsFilter() {
    if (this.userProfile.userType == "Tenant") {
      this.tenantOptions = this.tenantOptions.filter(col => this.getUserDataScope().authTenantList.includes(col.value));
    }
  }
}
